import { gql } from '@apollo/client';
import { challengeFragment } from '../queries/challenge';

export const UPDATE_CHALLENGE = gql`
  mutation update($input: ChallengeInput!) {
    updateChallenge(input: $input) {
      ...ChallengeWithData
    }
  }
  ${challengeFragment}
`;

export const CREATE_CHALLENGE = gql`
  mutation create($input: CreateChallengeInput!) {
    createChallenge(input: $input) {
      ...ChallengeWithData
    }
  }
  ${challengeFragment}
`;

export const CLONE_CHALLENGE = gql`
  mutation clone($id: ID!) {
    cloneChallenge(id: $id) {
      ...ChallengeWithData
    }
  }
  ${challengeFragment}
`;
